import Vue from 'vue'
import PaginationInstall from './install'

Vue.use(PaginationInstall)
